import type { Theme, ResolvedTheme } from '../../shared/types';

const KEY = 'canary.theme';
const SYSTEM_QUERY = '(prefers-color-scheme: dark)';

export function getInitialTheme(): Theme {
  const stored = localStorage.getItem(KEY) as Theme | null;
  if (stored === 'dark' || stored === 'light' || stored === 'system') return stored;
  return 'light';
}

export function resolveTheme(pref: Theme): ResolvedTheme {
  if (pref === 'system') {
    return window.matchMedia(SYSTEM_QUERY).matches ? 'dark' : 'light';
  }
  return pref;
}

export function persistTheme(pref: Theme): void {
  localStorage.setItem(KEY, pref);
  document.documentElement.dataset.theme = resolveTheme(pref);
}

export function watchSystem(onChange: (resolved: ResolvedTheme) => void): () => void {
  const mq = window.matchMedia(SYSTEM_QUERY);
  const handler = (e: MediaQueryListEvent) => onChange(e.matches ? 'dark' : 'light');
  mq.addEventListener('change', handler);
  return () => mq.removeEventListener('change', handler);
}
